import Modal from 'antd/lib/modal'
import 'antd/lib/modal/style/index.less'

export default Modal
